import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import CarouselMain from './Common/Carousel/Carousel';
import Navbar from './Navbar/Navbar';
import Footer from './Footer/Footer';
import BannerSetting from './Common/Carousel/BannerSetting.js';

import Box from '@mui/material/Box';

import HomeIcon from '@mui/icons-material/Home';
import InventoryIcon from '@mui/icons-material/Inventory';
import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const MainLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomeRoute = location.pathname === '/';

  return (
    <>
      <header style={{ position: 'relative' }}>
        <div
          style={{ position: 'absolute', top: 0, width: '100%', zIndex: 10 }}
        >
          <Navbar />
        </div>
        {isHomeRoute ? <CarouselMain /> : <BannerSetting />}
      </header>
      <main>
        <Outlet />
      </main>
      <Box
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 2000,
        }}
      ></Box>
      <Footer />
    </>
  );
};

export default MainLayout;
